import { forwardRef } from 'react'
import { FiCalendar, FiChevronDown } from 'react-icons/fi'
import { cn } from '../../utils/cn'

interface Props {
  value?: string
  onClick?: () => void
  // 'pill' matches the superadmin table filter: calendar first, then the
  // range, then a chevron. 'default' keeps the chart filters unchanged.
  variant?: 'default' | 'pill'
  // Not named `placeholder`: react-datepicker injects that prop itself when
  // cloning customInput, which would overwrite whatever we pass.
  emptyLabel?: string
  className?: string
}

const CustomDatePicker = forwardRef<HTMLButtonElement, Props>(
  ({ value, onClick, variant = 'default', emptyLabel, className }, ref) => {
    const isPill = variant === 'pill'
    const label = value ? value : (emptyLabel ?? '')

    return (
      <button
        type='button'
        className={cn(
          'flex items-center border-solid rounded-lg text-sm text-textBlack',
          isPill
            ? 'gap-2 border-[1px] border-borderGray bg-white px-3 py-3 hover:bg-mainBg transition-colors'
            : 'gap-5 border-[1px] border-lightGray px-3 py-3',
          className,
        )}
        onClick={onClick}
        ref={ref}
      >
        {isPill && <FiCalendar className='text-base text-textBlack' />}
        <span className={cn(!value && 'text-lightGray')}>{label}</span>
        {isPill ? (
          <FiChevronDown className='text-base text-textBlack' />
        ) : (
          <FiCalendar className='text-base' />
        )}
      </button>
    )
  },
)

export default CustomDatePicker
